const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'base',
        'tableSimple',
        'table',
    ],

    config: {
        inline: true,
    },

    model: {
        loadedStatusIDs: {}, // stores all statusIDs loaded to determine if a refresh is necessary when heartbeat wants to refresh specific statusIDs.
        controller: false,
        parentEntityForTable: false
    },

    methods: {
        sanitizeResourceFilters: function(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
            if(areBaseTableResourceFilters){
                if(!this.model.parentEntityForTable){
                    this.model.parentEntityForTable = this.getResourceRegisterContent('parentEntityForTable') || false
                }
                if(!this.model.tableConfig){
                    this.model.tableConfig = this.getResourceRegisterContent('tableConfig') || {}
                }
                if(this.model.parentEntityForTable){
                    utils.refMerge(this.config, this.model.tableConfig)
                    utils.refMerge(resourceFilters, {
                        baseFilters:    this.model.parentEntityForTable.baseFilters || {},
                        filters:        this.model.parentEntityForTable.filters || {},
                    })
                }
            }
        },

        onPrepareDone: function(storage, isServer){
            // NOTE: overwrite if necessary
        },

        onResourceSanitized(){
            // NOTE: overwrite if necessary
            this.storeLoadedStatusIDs()
        },

        addEntity: function(entity, prevEntity){
            // add entity to dom if possible
            if(this.config.isReady && (this.model.$table || []).length > 0){
                this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
            }
        },

        // stores loadedStatusIDs
        storeLoadedStatusIDs(){
            this.model.loadedStatusIDs = {}
            for(const e in this.model.entityList){
                for(const statusID in (((this.model.entityList[e] || {}).attributes || {}).statusFlagsSummary || {}).statusIDs || {}){
                    this.model.loadedStatusIDs[statusID] = true
                }
            }
        },

        /**
         * is at least of the given statusIDs loaded
         * @param statusIDs     object - {<statusID>: true, ...}
         * @returns {boolean}
         */
        isAtLeastOneStatusIDLoaded(statusIDs){
            for(const statusID in statusIDs || {}){
                if((this.model.loadedStatusIDs || {})[statusID]){
                    return true
                }
            }

            return false
        },

        showInsert(buttonContext, buttonMode){
            // NOTE: overwrite if necessary
            if(this.model.controller){
                if(utils.isFunction(this.model.controller.showInsert)){
                    this.model.controller.showInsert.apply(this.model.controller, arguments)
                }
            }
        },

        showEdit(entityID, entityData){
            // NOTE: overwrite if necessary
            if(this.model.controller){
                if(utils.isFunction(this.model.controller.showEdit)){
                    if(this.config.usage === 'selection' && this.config.isMultiSelect){
                        this.toggleRowSelection(entityID, entityData)
                    } else {
                        this.model.controller.showEdit(this.config.buttonContext, entityID, entityData)
                    }
                }
            }
        },

        delete(entityID, entityData){
            // NOTE: overwrite if necessary
            if(this.model.controller){
                if(utils.isFunction(this.model.controller.delete)){
                    this.model.controller.delete(this.config.buttonContext, entityID, entityData)
                }
            }
        },

        onSubmitDone(callerComponent, entityID, entityData, insertPerformed){
            // NOTE: overwrite if necessary
        },

        postDeleteRecord(callerComponent, buttonContext, entityID, entityData){
            // NOTE: overwrite if necessary
        },

        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers = this.config.heartbeatRefreshOn || {}
            const key = message.heartbeatKey
            if(refreshers[key]){
                this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    },

    hooks: {
        _attach($element, options){
            if(!this.model.controller){
                this.closest('templates_core_controller_controller', controller => {
                    this.model.controller = controller
                })
            }
        },

        toggleRowSelection: function($element, options){
            this.toggleRowSelection(options.rowID, options.rowData);
        },
    },

    handlers: [
        {
            name: 'onSubmitDone',
            componentClass: 'templates_core_form_propertiesForm',
            handle: function(callerComponent, resourceData, insertPerformed){
                resourceData = resourceData || {}
                const entityData = resourceData.data || {}
                const entityID = (entityData.attributes || {})[entityData.primaryKey || 'id'];
                this.onSubmitDone(callerComponent, entityID, entityData, insertPerformed)
            }
        },
        {
            name: 'postDeleteRecord',
            handle: function(callerComponent, buttonContext, entityID, entityData){
                this.postDeleteRecord(callerComponent, buttonContext, entityID, entityData)
            }
        },
    ]
}